import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableFooter from "@mui/material";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import { CardHeader } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { WHITE } from "../colors";
import Banner from "../components/banners/Banner";
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import { useEffect, useState } from "react";
import {Chip} from "@mui/material";

export default function EmployeeListContainer(props) {
  const { userClicked } = props;
  const [page, setPage] = useState(1);
  const itemsPerPage = 8; // You can adjust this value as per your requirement

  
  

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '80vh' }}>
    <TableContainer component={Paper} sx={{ opacity: 0.9, borderRadius: 4, flexGrow: 1 }}>
      <Table
        sx={{
          minWidth: 650,
          backgroundColor: WHITE,
        }}
        stickyHeader
        aria-label="sticky table"
      >
        <TableHead>
          <TableRow>
          <TableCell></TableCell>
            <TableCell>Username</TableCell>
            <TableCell align="center">Phone</TableCell>
            <TableCell align="center">Role</TableCell>
            {/* <TableCell align="center">Submitted Inquiries</TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {props.employees &&
            props.employees.length > 0 &&
            props.employees
              .slice((page - 1) * itemsPerPage, page * itemsPerPage)
              .map((emp) => (
                <TableRow
                  key={emp.id}
                  hover
                  onClick={() => userClicked(emp)}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      alt="Remy Sharp"
                      src={emp.imagePath || "/static/images/avatar/1.jpg"}
                    />
                  </TableCell>
                  <TableCell align="left">{emp.name}</TableCell>
                  <TableCell align="center">{emp.phone}</TableCell>
                  <TableCell align="center"><Chip color= {emp.Role.id===1? 'primary':'default'} label={emp.Role.name}></Chip></TableCell>
                  {/* <TableCell align="center">{emp?.inquiries}</TableCell> */}
                </TableRow>
              ))}
        </TableBody>

      </Table>
      {props.employees && props.employees.length === 0 && (
        <Banner message="No Users found" />
      )}
      
    </TableContainer>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
      <Pagination
        count={props.employees && props.employees.length && Math.ceil(props.employees.length / itemsPerPage)}
        page={page}
        onChange={(event, value) => setPage(value)}
      />
    </Box>
   
  </div>
  
  );
}
